import { Base, Component, Prop } from '@/vue-property-decorator'
import { useMainStore } from '@/store/index'
import DateUtils from '@/utils/DateUtils'
import Skin from '@/controller/Skin'
import moment from 'moment'
import style from './style.module.scss'

export interface CountTimeRenderParams {
  time?: string
  timeZonePre?: string
  timeZone?: string
}
type Props = {
  /** 格式化时间 */
  format: string
}

interface ScopedSlots {
  default?: CountTimeRenderParams
}

@Component<CountTime>({
  name: 'CountTime'
})
export default class CountTime extends Base<
  unknown,
  unknown,
  unknown,
  ScopedSlots
> {
  @Prop({ required: false })
  private readonly format!: Props['format']

  private time = ''
  private timer: NodeJS.Timer | undefined

  mounted() {
    this.updateSystemTime()
  }

  beforeDestroy() {
    this.timer && clearInterval(this.timer)
  }

  private updateSystemTime() {
    const { siteInfos } = useMainStore()
    const utcOffset = siteInfos?.timeZone?.split(' ')[1]
    if (utcOffset) {
      const momentTime = moment().utcOffset(utcOffset).toLocaleString()
      this.time = DateUtils.format(
        momentTime,
        // isStake || isEuropeanAmerican || isClassicStyle
        //   ? 'MM/DD  HH:mm:ss'
        //   : 'YYYY/MM/DD  HH:mm:ss',
        this.format || 'MM/DD  HH:mm:ss',
        { utcOffset }
      )
      this.timer = setInterval(() => {
        const momentTime = moment().utcOffset(utcOffset).toLocaleString()

        this.time = DateUtils.format(
          momentTime,
          // isStake || isEuropeanAmerican || isClassicStyle
          //   ? 'MM/DD  HH:mm:ss'
          //   : 'YYYY/MM/DD  HH:mm:ss',
          this.format || 'MM/DD  HH:mm:ss',
          { utcOffset }
        )
      }, 1000)
    }
  }

  private commonRender() {
    const { siteInfos } = useMainStore()
    const timeZone = siteInfos?.timeZone?.split(' ')[1]
    return (
      this.$scopedSlots.default?.({
        time: this.time,
        timeZonePre: 'UTC',
        timeZone
      }) || (
        <span>
          {this.time}
          UTC
          {timeZone}
        </span>
      )
    )
  }

  private Theme15Render() {
    const { siteInfos } = useMainStore()
    return (
      <span>
        {this.time}
        &nbsp;&nbsp; (UTC
        {siteInfos?.timeZone?.split(' ')[1]})
      </span>
    )
  }

  //stake模式
  private stakeRender() {
    const { siteInfos } = useMainStore()
    return (
      <span class={style['stakeTime']}>
        <span class={style.utc}>
          {/* (UTC) {utcOffsetOfHours >= 0 && '+'} {utcOffsetOfHours} */}
          (UTC
          {siteInfos?.timeZone?.split(' ')[1]})
        </span>
        <span>{this.time}</span>
      </span>
    )
  }

  // 普通模式，经典版/欧美版
  private normalRender() {
    const { siteInfos } = useMainStore()
    return (
      <span class={style['stakeTime']}>
        <span>{this.time}</span>
        <span class={style.utc}>
          {/* (UTC) {utcOffsetOfHours >= 0 && '+'} {utcOffsetOfHours} */}
          (UTC
          {siteInfos?.timeZone?.split(' ')[1]})
        </span>
      </span>
    )
  }

  render() {
    const { isStake, isEuropeanAmerican, isClassicStyle, isTheme15 } =
      Skin.currentTheme()
    return (
      <span class="count-time-box">
        {isStake
          ? this.stakeRender()
          : isClassicStyle || isEuropeanAmerican
          ? this.normalRender()
          : isTheme15
          ? this.Theme15Render()
          : this.commonRender()}
      </span>
    )
  }
}
